export default "__VITE_ASSET__Cr1p2JUm__"